import { DomainCode } from "src/app/models/common/model";
import { RejectionReasonModel } from "src/app/models/common/myteam-model";
import { PhoneModel } from "src/app/models/common/phone-model";
import { ServiceMasterModel } from "src/app/models/common/service-master.model";
import { RequirementsModel, RequirementError } from "src/app/pages/one-way-data/request/requirements-model";
import { LocationModel } from "../../../models/container_master_model/location";
import { ILeadCompanyModel, InviteModelForLeadVerification, LeadInviteModelErrors } from "../lead-verification/lead-invite.model";
import { LeadVerificationError } from "../lead-verification/lead-verification.model";
import { UserRole } from "src/app/models/common/user-role";
import { CountryModel } from "src/app/models/common/countrymodel";
import { StateNestedModel } from "src/app/models/common/statemodel";
import { ContainerSizeType } from "src/app/models/container_master_model/sizeType";


export class LeadModel {
    id?: string;
    pol_list?: LocationModel[];
    pod_list?: LocationModel[];
    requirements?: RequirementsModel[];
    is_active?: boolean;
    transaction_type?: any;
    client_ip?: string;
    client_browser?: string;
    client_device?: string;
    request_source?: string;
    email?: string;
    mobile?: string;
    remarks?: string;
    // is_lead_approved?: boolean;
    lead_status?: string;
    request_type?: any;
    rejection_reason?: RejectionReasonModel;
    // leadApprovalList = [
    //     {
    //         id: 'approved',
    //         value: 'Approved'
    //     },
    //     {
    //         id: 'rejected',
    //         value: 'Rejected'
    //     }
    // ];
    constructor(data = null) {
        this.id = data ? data.id : null;
        this.pol_list = data ? data.pol_list : [];
        this.pod_list = data ? data.pod_list : [];
        this.requirements = data ? data.requirements.map(item => new RequirementsModel(item)) : [new RequirementsModel()];
        this.transaction_type = data ? data.transaction_type : null;
        this.client_ip = data ? data.client_ip : null;
        this.client_browser = data ? data.client_browser : null;
        this.client_device = data ? data.client_device : null;
        this.request_source = data ? data.request_source : null;
        this.email = data ? data.email : null;
        this.mobile = data ? data.mobile : null;
        this.remarks = data ? data.remark : null;
        this.lead_status = data ? data.lead_status : null;
        this.request_type = data ? data.request_type : null;
        this.rejection_reason = data ? data.rejection_reason : null;
    }


    getLeadPayload() {
        console.log("requirements", this.requirements)
        return {
            id: this.id,
            pol_list: this.pol_list.map((item) => item.id),
            pod_list: this.pod_list.map((item) => item.id),
            requirements: this.request_type.dev_name == 'one_way' ? this.requirements.map((item) => item.getOneWayRequirementPayload()) : this.request_type.dev_name == 'buy_sell' ? this.requirements.map((item) => item.getTradeRequirementPayload()) : this.requirements.map((item) => item.getLeaseRequirementPayload()),
            transaction_type: this.transaction_type,
            client_ip: this.client_ip,
            client_browser: this.client_browser,
            client_device: this.client_device,
            request_source: this.request_source,
            email: this.email,
            mobile: this.mobile,
            remarks: this.remarks,
            lead_status: this.lead_status,
            request_type: this.request_type.id,
            rejection_reason: typeof this.rejection_reason == 'object' && this.rejection_reason != null ? this.rejection_reason.id : this.rejection_reason,
        }
    }


}

export class InviteModel {
    id: string;
    email: string;
    first_name: string;
    last_name: string;
    phone: PhoneModel;
    company: ILeadCompanyModel;
    remarks: string;
    is_login_approved: any;
    bypass_external_verification: boolean;
    rejection_reason: any;
    country: string;
    state: string;
    address: string;
    loginApprovalList_Up = [
        {
            id: 'yes',
            value: 'Yes'
        },
        {
            id: 'no',
            value: 'No'
        },
    ];
    loginApprovalList = [
        {
            id: 'yes',
            value: 'Yes'
        },
        {
            id: 'no',
            value: 'No'
        },
        {
            id: 'under_process',
            value: 'In Process'
        }
    ]
    error: LeadError;

    lead?: LeadModel;
    constructor(data = null) {
        this.id = data ? data.id : null;
        this.email = data ? data.email : null;
        this.first_name = data ? data.first_name : null;
        this.last_name = data ? data.last_name : null;
        this.phone = data ? data.phone.as_e164 : null;
        this.company = data ? data.company : null;
        this.is_login_approved = data ? data.approval_status == 'rejected' ? this.loginApprovalList[1] : this.loginApprovalList[0] : null;
        this.rejection_reason = data ? data.rejection_reason : null;
        this.bypass_external_verification = false;
        this.remarks = data ? data.remarks : null;
        this.lead = new LeadModel();
        this.resetLeadErrors();
    }

    getLeadCreatePayload() {
        return {
            email: this.email,
            first_name: this.first_name,
            last_name: this.last_name,
            phone: this.phone?.as_e164,
            company: this.company?.id,
            is_login_approved: this.is_login_approved,
            rejection_reason: typeof this.rejection_reason == 'object' && this.rejection_reason != null ? this.rejection_reason.id : this.rejection_reason,
            bypass_external_verification: this.bypass_external_verification,
            remarks: this.remarks,
            lead: this.lead.getLeadPayload(),
        }
    }
    resetLeadErrors() {
        this.error = {
            transaction_type: [],
            request_source: [],
            pol_list: [],
            pod_list: [],
            rejection_reason:[],
        }
    }
    is_lead_valid() {
        this.resetLeadErrors();

        if (this.lead.transaction_type == null || this.lead.transaction_type == '') {
            this.error.transaction_type = ['position is required'];
        }
        if (this.lead.request_source == null || this.lead.request_source == '') {
            this.error.request_source = ['Lead Source is required'];
        }
        if (this.lead.pol_list.length==0) {
            this.error.pol_list = ['POLs List is required'];
        }
        if(this.lead.request_type.dev_name!='buy_sell'){
            if (this.lead.pod_list.length==0) {
                this.error.pod_list = ['PODs List is required'];
            }
        }
        // if (this.rejection_reason == null || this.rejection_reason == '') {
        //     this.error.rejection_reason = ['This field is required'];
        // }

        return this.error.transaction_type.length == 0 && this.error.request_source.length == 0 && this.error.pol_list.length == 0 && this.error.pod_list.length == 0;
    }
}

export class LeadError {
    transaction_type: string[];
    request_source: string[];
    pol_list: string[];
    pod_list: string[];
    rejection_reason:string[];
}
